import { Heading } from "@athena/forge";
import MutedText from "./MutedText";

export interface HeaderPropsType {
  description?: string[];
  descriptionTextAlign?: string;
  headerText?: string;
  fontSize?: string;
  fontWeight?: string;
  fontColor?: string;
  marginBottom?: string;
}

function Header({
  headerText,
  description = [],
  descriptionTextAlign = "center",
  fontSize = "default",
  fontWeight = "semibold",
  fontColor = "default",
}: HeaderPropsType): React.JSX.Element {
  const descriptionElement = (): React.JSX.Element => {
    return (
      <>
        {description.map((item, index) => (
          <div key={index}>
            <MutedText
              className={`uiam-header-description fe_u_font-size--small fe_u_text-align--${descriptionTextAlign}`}
              key={index}
              text={item}
            />
            {index < description.length - 1 && <br />}
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="fe_u_text-align--center fe_u_margin--bottom-large">
      <Heading
        className={`fe_u_margin--bottom-medium fe_u_font-size--${fontSize} fe_u_font-weight--${fontWeight} fe_u_color--${fontColor}`}
        headingDescription={descriptionElement()}
        text={headerText}
        variant="subsection"
        headingTag="h3"
      ></Heading>
    </div>
  );
}

export default Header;
